import React from 'react'

import Programa from "../Assets/programa.jpeg"
import HuesoReparacion from "../Assets/Recurso2.jpg"

const Ponente = () => {
  return (
    <div id='programa' className='about-section-container'>
       <div className='about-section-text-container'>           
           <h1 className='primary-heading'>GIAN LUCA ROVESTI</h1>
           <div className='about-buttons-container'>               
                <p className='primary-subheading'> Graduado en la Universidad de Parma en 1982. 
                Jefe del servicio quirúrgico en la Clínica veterinaria “M. E. Miller” en Cavriago, Italia. 
                Ha pasado periodos de estudio en las universidades de Zúrich, Colorado, Florida, Carolina del Norte y 
                en el centro de Veterinarios especialistas de Costa del Golfo en Houston. Aprobó los exámenes de certificación 
                del Colegio Europeo de Cirujanos Veterinarios (ECVS) en 1997. En congresos nacionales y internacionales pronunció 
                alrededor de 200 conferencias y fue invitado a disertar en la reunión del Colegio de Cirujanos Veterinarios de los
                Estados Unidos (ACVS). Fue director del curso avanzado de la Fundación AO y de numerosos cursos de ortopedia. Fue 
                catedrático emérito es ortopedia para la Universidad de Viena entre 2009 y 2010. Es autor de alrededor 60 publicaciones, 
                varias de ellas en revistas científicas internacionales y desde el año 2005 es editor del manual oficial para la 
                certificación e la academia europea internacional e la AO. Su línea e investigación se concentra principalmente 
                sobre la tracción esquelética intraoperatoria, artroscopia, cirugía e rodilla y técnica híbrida e fijación externa.</p>
               
           </div>
           
       </div>
       <div className='home-image-container'>
            <img src={HuesoReparacion} alt="" />            
        </div>
    </div>
  )
}

export default Ponente